module.exports = __webpack_public_path__ + "img/solution--simplify-caregiver-procedures.2d9a372a.png";